import { styled } from '@mui/material/styles';
import { DatagridConfigurable } from 'shared/react-admin/Datagrids';
import { ImageField } from 'shared/react-admin/Fields';
import { getColumnStyle } from 'utils';

export const ConfigurableDatagridStyled = styled(DatagridConfigurable)({
  '& .MuiTableCell-root': {
    verticalAlign: 'middle !important',
  },
  '& .column-originId': getColumnStyle(108),
  '& .column-createdAt': getColumnStyle(150),
  '& .column-isCritical': { textAlign: 'center' },
  '& .column-errorCode': { ...getColumnStyle(108), textAlign: 'center' },
  '& .column-reason': { minWidth: '142px' },
});

export const ImageFieldStyled = styled(ImageField)({
  '& .RaImageField-image': {
    margin: 0,
    marginRight: '2px',
    maxWidth: 24,
    maxHeight: 24,
    minWidth: 24,
    minHeight: 24,
    objectFit: 'contain',
  },
});
